import {
  WORK_ORDER_TECHNICIAN_SUMMARIES_SUCCESS
} from '../actions/technician-service-summaries'

export default function (state = [], action) {
  switch (action.type) {
    case WORK_ORDER_TECHNICIAN_SUMMARIES_SUCCESS: {
      return {
        ...state,
        [action.payload.workOrderId]: {
          ...action.payload.entities.technicianServiceSummaries
        }
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/technician-service-summaries.js